import OlTile from 'ol/layer/Tile';
import OlTileWMS from 'ol/source/TileWMS';
import { getRequestUrl } from '../';
import { HIGHRES, DEFAULTRES } from '../../../../constants';
import { first } from 'lodash';

export const createWmsLayer = function (store, layerData, extent, highQuality) {
    let styleName = '';
    let version = '1.3.0';
    const requestWithToken = !store.getters.isWeb && layerData.isSecured;

    // allways use custom endpoint for high quality (cors)
    const url = highQuality ? layerData.customEndPoints.wms.url : getRequestUrl(layerData);

    if (typeof first(layerData.styles) !== 'undefined') {
        styleName = first(layerData.styles).name;
    }
    if (layerData.owsVersionWms < 1.3 && styleName === '' && layerData.owsVersionWfs !== 0) {
        styleName = layerData.layerName ;
        version = '1.1.1';
    }

    // To force styles= to be added to the URL make sure it is not null but '' instead.
    styleName = styleName ?? '';

    // create common paramaters
    const commonNonFeedbackTleLayerParameters = {
        LAYERS: layerData.layerName,
        TILED: layerData.tiledRequest,
        STYLES: styleName,
        VERSION: version,
        FORMAT: layerData.format
    };

    let source;
    if (extent === null) {
        source = new OlTileWMS({
            crossOrigin: highQuality ? 'Anonymous' : undefined,
            url: url,
            params: commonNonFeedbackTleLayerParameters,
            tileLoadFunction: requestWithToken ? ngApiSecuredTileLoadFunction(store, layerData) : undefined
        });
    } else {
        source = new OlTileWMS({
            crossOrigin: highQuality ? 'Anonymous' : undefined,
            url: url,
            params: {
                ...commonNonFeedbackTleLayerParameters,
                TILESORIGIN: `${extent[0]},${extent[1]}`
            },
            tileLoadFunction: requestWithToken ? ngApiSecuredTileLoadFunction(store, layerData) : undefined
        });
    }
    return new OlTile({
        title: layerData.title,
        id: layerData.id,
        combinedId: layerData.getCombinedOlId(),
        type: 'WMS',
        preload: 5,
        opacity: 1,
        visible: true,
        source
    });
};

// function to override loading directly from url,
// using the api with bearer token if available
export const ngApiSecuredTileLoadFunction = (store, layerData, highResolution) => async (imageTile, src) => {
    const url = setQualityUrlParameters(highResolution, new URL(src));
    const searchParams = new URLSearchParams(url.search);
    const searchParamsObject = Object.fromEntries(searchParams);
    try {
        // make the request with responsetype blob
        const tileData = await store.dispatch('useApiData', {
            name: 'GetWebMapByLayerId',
            parameters: { Id: layerData.id, ...searchParamsObject },
            config: { responseType: 'blob' }
        });
        // create imageurl from blob
        imageTile.getImage().src = URL.createObjectURL(tileData.data);
    } catch (error) {
        // fall back to original src
        imageTile.getImage().src = src;
    }
};

// function to use parameters to get hight reselution tiles
export const ngApiHighQualityTileLoadFunction = (highResolution) => (imageTile, src) => {
    const url = setQualityUrlParameters(highResolution, new URL(src));
    imageTile.getImage().src = url.toString();
};

// function to set parameters to get hight reselution tiles
export const setQualityUrlParameters = (highResolution, url) => {
    if (!highResolution) {
        return url;
    }
    const ratio = HIGHRES / DEFAULTRES;
    url.searchParams.set('WIDTH',  url.searchParams.get('WIDTH') * ratio);
    url.searchParams.set('HEIGHT', url.searchParams.get('HEIGHT') * ratio);
    url.searchParams.set('map_resolution', highResolution ? HIGHRES : DEFAULTRES);
    return url;
};
